"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fromEventPattern_1 = require("rxjs/observable/fromEventPattern");
var Reader_1 = require("fp-ts/lib/Reader");
function fromHistory(history) {
    var unlisten;
    var listen = function (handler) {
        unlisten = history.listen(function (location, action) { return handler({ location: location, action: action }); });
    };
    return fromEventPattern_1.fromEventPattern(listen, function () {
        if (unlisten) {
            unlisten();
        }
    });
}
var RoutingUtils;
(function (RoutingUtils) {
    RoutingUtils.route$ = Reader_1.asks(function (history) {
        return fromHistory(history)
            .distinctUntilChanged(function (a, b) { return a.location === b.location && a.action === b.action; })
            .startWith({ location: history.location, action: history.action })
            .shareReplay(1);
    });
})(RoutingUtils = exports.RoutingUtils || (exports.RoutingUtils = {}));
